module.exports = __webpack_public_path__ + "static/media/3_2.27c702cf.jpg";